import styled from 'styled-components';

export const StyledModularReeditBanner = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100vw;
    background-color: ${(p) => p.theme.colors.supportingErrorFill};
    padding: 16px 72px;
    position: fixed;
    top: 60px;
    left: 0;
    z-index: 2;
    box-sizing: border-box;
`;

export const StyledModularReeditBannerHeader = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`;

export const StyledModularReeditBannerPadding = styled.div<{ $padding: number }>`
    height: ${(p) => p.$padding}px;
    width: 100%;
`;
